/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';
export var NavigationGroupContext = createContext({
  group: undefined
});
export var useNavigationGroupContext = function useNavigationGroupContext() {
  return useContext(NavigationGroupContext);
};
//# sourceMappingURL=context.js.map